export const AuthoritiesConstants = {
    CAN_LOGIN: "CAN_LOGIN",
    ASSIGN_SALES_EXCEPTION: "ASSIGN_SALES_EXCEPTION",
    CREATE_EXPERT_FREE: "CREATE_EXPERT_FREE",
    CREATE_FREE_LEADS: "CREATE_FREE_LEADS",
    UPDATE_ASSIGNATION_SALES: "UPDATE_ASSIGNATION_SALES",
    UPDATE_PRICING_SYSTEM: "UPDATE_PRICING_SYSTEM",
    UPDATE_ACCOUNT_MANAGER: "UPDATE_ACCOUNT_MANAGER",
    CHANGE_VENDOR: "CHANGE_VENDOR",
    DELETE_MEMBER_STOP: "DELETE_MEMBER_STOP",
    UPDATE_USER: "UPDATE_USER",
    /** POST non-compete pair (user details). DB: t_authorities + t_usergroup_department_authorities. */
    CREATE_NO_COMPETE: "CREATE_NO_COMPETE",
    /** DELETE non-compete pair (user details). */
    DELETE_NO_COMPETE: "DELETE_NO_COMPETE",
    MEMBER_AFFILIATE_PIXEL_UPDATE: "MEMBER_AFFILIATE_PIXEL_UPDATE",
    SEND_INVOICE_EMAIL: "SEND_INVOICE_EMAIL",
    CREATE_AFFILIATE: "CREATE_AFFILIATE",
    UPDATE_SALES_SELECT: "UPDATE_SALES_SELECT",
    UPDATE_SUPPLIER_PROTEST_DATA: "UPDATE_SUPPLIER_PROTEST_DATA",
    CREATE_ASSIGNATION_SALES:"CREATE_ASSIGNATION_SALES",
    CREATE_COMPANY_HISTORY:"CREATE_COMPANY_HISTORY",
    UPDATE_CRM_COMMENT: "UPDATE_CRM_COMMENT", 
    VIEW_SALES_FILTER: "VIEW_SALES_FILTER",
    CREATE_EXPERTBUSTYPE_PRICE: "CREATE_EXPERTBUSTYPE_PRICE",
    CREATE_NSL: "CREATE_NSL",
    DELETE_INVOICE: "DELETE_INVOICE",
    READ_PARTNERSUBMISSION_PROTEST: "READ_PARTNERSUBMISSION_PROTEST",
    VIEW_PARTNER_RFP_MANAGEMENT_DATA: "VIEW_PARTNER_RFP_MANAGEMENT_DATA",
    CHANGE_PARTNERSUBMISSION_PROTEST: "CHANGE_PARTNERSUBMISSION_PROTEST",
    ACTIVATE_USER: "ACTIVATE_USER",
    VIEW_SALES_SUPPLIERS: "VIEW_SALES_SUPPLIERS",
    VIEW_CHARTS: "VIEW_CHARTS",
    VIEW_CHARTS_ADMIN: "VIEW_CHARTS_ADMIN",
    VIEW_CHARTS_PLUS: "VIEW_CHARTS_PLUS",
    CHANGE_TEASING_AND_SUPPLIER: "CHANGE_TEASING_AND_SUPPLIER", // Authority ID_user_group 3, ID_department 1 (admin) in t_usergroup_department_authorities

    // Reload (ReactBackoffice + ReactGovexBackoffice sitemap)
    RELOAD_FRONTOFFICE: "RELOAD_FRONTOFFICE",
    RELOAD_BACKOFFICE: "RELOAD_BACKOFFICE",

    // Backoffice + Govex sitemap (existing in backoffice React/Spring)
    PARTNER_RFP_SEARCH: "PARTNER_RFP_SEARCH",

    // Govex sitemap: feature authorities in t_authorities / t_usergroup_department_authorities
    /** Access to BDA and JOUE sections. Assign to e.g. usergroup 3, 7 with department admin (1). */
    MANAGE_BDA_JOUE: "MANAGE_BDA_JOUE",
    /** bo_user_govex_subscrsearch (subscription/invoicing search). */
    READ_INVOICE: "READ_INVOICE",
    /** bo_user_govex_search (user search). */
    READ_USER: "READ_USER",

    // Withheld list
    VIEW_AFFILIATE: "VIEW_AFFILIATE",

    // External lead distribution (REBO-762)
    EXTERNAL_LEAD_VIEW: "EXTERNAL_LEAD_VIEW",

    // Sales dashboards (REBO-800)
    /** See every vendor's opportunities instead of only one's own. Backend: VendorScopeResolver. */
    VIEW_ALL_OPPORTUNITIES: "VIEW_ALL_OPPORTUNITIES",

    // Supplier marketing (REBO-467)
    /**
     * Opens the supplier marketing dashboard for the sales department, pinned on the connected
     * vendor. VIEW_CHARTS_PLUS is what unlocks the vendor picker and the cross-vendor pages.
     */
    VIEW_SPM_DASHBOARD: "VIEW_SPM_DASHBOARD",

    // Stats / costs (existing in backoffice DB)
    UPDATE_AFFILIATE_COST: "UPDATE_AFFILIATE_COST",
    READ_COST: "READ_COST",
    /**
     * /categories/get-all, which feeds the category filter of the stats pages. Held by the five
     * ADMIN departments and by no OPERATOR, as of 2026-09-30 in
     * t_usergroup_department_authorities — so a page open to VIEW_CHARTS has to check it before
     * offering that filter.
     */
    READ_CATEGORY: "READ_CATEGORY",
    UPDATE_EXPERTROLE: "UPDATE_EXPERTROLE",
    UPDATE_ADMINISTRATOR_REMOTE_ACCESS: "UPDATE_ADMINISTRATOR_REMOTE_ACCESS",
    UPDATE_PARTNER_RFP: "UPDATE_PARTNER_RFP",
    UPDATE_PARTNER_SUBMISSION: "UPDATE_PARTNER_SUBMISSION",

    // Notifications (REBO-916)
    VIEW_NOTIFICATIONS: "VIEW_NOTIFICATIONS",

    // AI fraud check (AI-85): re-run + manual Legit/Not legit verdict; management department only
    MANAGE_AI_FRAUD_CHECK: "MANAGE_AI_FRAUD_CHECK",

    // Integration errors (REBO-935): dismiss/erase a dispatch error. Admin/IT only — seed in
    // t_authorities + assign to the admin/IT usergroup+department.
    DISMISS_INTEGRATION_ERROR: "DISMISS_INTEGRATION_ERROR",

    // leads-edit (REBO-952): UTM source/medium/campaign, template and affiliate colour block of a lead.
    // Admin/marketing/IT departments only, like the legacy partnerrfp_bottom.jsp / partnerrfp_form.jsp
    VIEW_PARTNER_RFP_SOURCE: "VIEW_PARTNER_RFP_SOURCE",
    // leads-edit contact card: edit pencils (inline-update endpoint) and the 3CX call log
    PARTNER_RFP_EDIT: "PARTNER_RFP_EDIT",
    // New React lead pages (lead lists + leads-edit) instead of the legacy ones, for the operators testing them.
    // Temporary: drop it (and the legacy links) once everyone is on the new pages.
    PARTNER_RFP_NEW_PAGES: "PARTNER_RFP_NEW_PAGES",
    READ_CALL_LOG_3CX: "READ_CALL_LOG_3CX",
    MANAGE_TOKENS: "MANAGE_TOKENS",
    // Create/edit/revoke the member API tokens of clients and read their API calls (IT and admin departments)
    MANAGE_MEMBER_API_TOKENS: "MANAGE_MEMBER_API_TOKENS"
}